import { gameState } from "appworks/model/game-state";
import { commsManager } from "appworks/server/comms-manager";
import { Contract } from "appworks/utils/contracts/contract";
import { GambleInitRequestPayload } from "slotworks/model/gameplay/requests/gamble-init-request-payload";

export function GambleInitCommand(): Contract<void> {
    const payload = new GambleInitRequestPayload();
    const record = gameState.getCurrentGame().getCurrentRecord();
    payload.gambleID = record.gambleID;
    payload.stake = record.gambleStake;

    return commsManager.request(payload);
}
